import { Box, styled } from "@mui/material";
import { FC } from "react";

/** Design token: Border Color/Error & Text Color/Error. */
const SEAL_COLOR = "#E57373";

type TSealPreviewProps = {
  value?: string;
  size?: number;
};

const getFontSize = (size: number, length: number): number => {
  if (length <= 1) return size * 0.46;
  if (length === 2) return size * 0.34;
  return size * 0.28;
};

/** Seal layout rule: 1-2 chars on a single line; 3+ chars wrap to two lines (first 2 chars, then the remainder). */
const toSealLines = (chars: string[]): string[] => (chars.length <= 2 ? [chars.join("")] : [chars.slice(0, 2).join(""), chars.slice(2).join("")]);

export const SealPreview: FC<TSealPreviewProps> = ({ value, size = 40 }) => {
  const chars = Array.from((value ?? "").trim()).slice(0, 4);
  const lines = toSealLines(chars);

  return (
    <SealCircle $size={size}>
      {chars.length > 0 && (
        <SealChars $fontSize={getFontSize(size, chars.length)}>
          {lines.map((line, index) => (
            <span key={index}>{line}</span>
          ))}
        </SealChars>
      )}
    </SealCircle>
  );
};

const SealCircle = styled(Box, { shouldForwardProp: (prop) => prop !== "$size" })<{ $size: number }>`
  flex: none;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  min-width: ${({ $size }) => $size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1.5px solid ${SEAL_COLOR};
  color: ${SEAL_COLOR};
`;

const SealChars = styled(Box, { shouldForwardProp: (prop) => prop !== "$fontSize" })<{ $fontSize: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: ${({ $fontSize }) => $fontSize}px;
  font-weight: 700;
  line-height: 1.1;
`;
